var _path, _path2, _path3, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 859,
    height: 289,
    viewBox: "0 0 859 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72192 72.5572L16.9316 48.5627C17.548 46.5133 19.3327 45.3429 21.458 45.5946L46.3377 48.5465C46.7748 48.5978 47.1135 48.9315 47.2714 49.3173L25.9076 53.8871C24.6234 54.1623 23.5276 54.8809 22.7633 55.949L10.0566 73.7208C9.76578 73.4222 9.59474 72.9785 9.72191 72.5572L9.72192 72.5572Z",
    fill: "#DCD3FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M510.877 30.5898L534.44 36.5728C536.453 37.0843 537.661 38.7709 537.504 40.8502L533.713 64.7021C533.681 65.1297 533.371 65.4737 533.004 65.644L529.645 45.5381C529.325 44.3001 528.584 43.2646 527.517 42.5667L509.763 30.9657C510.04 30.6698 510.464 30.4842 510.877 30.5898L510.877 30.5898Z",
    fill: "#DCD3FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M741.736 255.365L741.282 235.563C741.243 233.871 740.129 232.604 738.456 232.349L718.874 231.009C718.53 230.956 718.201 231.14 718 231.4L733.323 237.735C734.244 238.214 734.928 238.992 735.286 239.967L741.237 256.181C741.521 256.015 741.745 255.713 741.736 255.365Z",
    fill: "#DCD3FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_111_1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M804 18.2492L824.371 10.3555C825.596 9.88149 826.906 9.88149 828.131 10.3555L848.503 18.2492C848.416 18.6955 848.114 19.0738 847.671 19.0738H804.832C804.39 19.0738 804.088 18.6955 804 18.2492Z",
    fill: "#735DFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_111_1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.054 278.75L359.203 266.473C359.933 265.735 360.879 265.312 361.916 265.258L378.455 265.847C378.536 266.197 378.441 266.567 378.121 266.71L363.376 272.156L347.921 279.076C347.602 279.219 347.261 279.044 347.054 278.75Z",
    fill: "#735DFE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_111_1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 278.756L102.336 249.472C101.694 247.712 100.468 246.307 98.8172 245.441L71.3581 234C70.9645 234.514 70.8446 235.194 71.2586 235.669L91.3018 255.678L111.344 278.641C111.758 279.116 112.443 279.083 113 278.756V278.756Z",
    fill: "#735DFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_111_1353",
    x: 794,
    y: 0,
    width: 64.502,
    height: 29.0737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_111_1353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_111_1353",
    x: 344.055,
    y: 262.258,
    width: 37.4277,
    height: 19.8691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_111_1353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_111_1353",
    x: 62,
    y: 225,
    width: 60,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_111_1353"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundBackground);
export default __webpack_public_path__ + "static/media/not-found-background.156f5f1c00fa99a954a8ca32a64262dd.svg";
export { ForwardRef as ReactComponent };